import { useForceUpdate } from '@/modules/shared/hooks/use-force-update'

interface ForceUpdateGateProps {
  children: React.ReactNode
}

/**
 * Dispara a checagem de atualização obrigatória (ver useForceUpdate) e
 * renderiza a árvore normalmente. O bloqueio visual, quando existe update,
 * é a tela cheia nativa do Google Play — este componente não desenha nada
 * próprio, só garante que a checagem rode no boot do app.
 */
export function ForceUpdateGate({ children }: ForceUpdateGateProps) {
  useForceUpdate()

  return <>{children}</>
}
